import React, { useEffect, useState } from 'react';
import './styles.scss';

interface OverlayState {
  visible: boolean;
  state?: 'wait' | 'confirm';
  purpose?: 'hide' | 'copy';
  name?: string;
  edid?: string; // editor id, when the name is something else
  ref?: string;
  type?: string;
  dist?: number | null; // metres
}

const Key: React.FC<{ k: string }> = ({ k }) => <kbd className="map-hide__key">{k}</kbd>;

// The tool that takes an object out of the map (admin, see mapHideService.ts): the object is picked in
// the game's console (exact), then this panel asks to confirm with its name, its type and how far it
// is. Only text: nothing is drawn on the object (following the camera cost far too much). Purely
// visual, always mounted, invisible until the client sends an update, never takes focus or clicks.
const MapHideOverlay: React.FC = () => {
  const [s, setS] = useState<OverlayState>({ visible: false });

  useEffect(() => {
    const handler = (e: Event) => setS(((e as CustomEvent).detail as OverlayState) ?? { visible: false });
    window.addEventListener('skymp5-client:mapHideOverlay', handler);
    return () => window.removeEventListener('skymp5-client:mapHideOverlay', handler);
  }, []);

  if (!s.visible) return null;

  const confirm = s.state === 'confirm';

  return (
    <div className="map-hide" role="status">
      <div className={'map-hide__panel' + (confirm ? ' is-confirm' : '')}>
        {confirm ? (
          <>
            <div className="map-hide__title">Masquer cet objet pour tous les joueurs ?</div>
            <div className="map-hide__subject">{s.name}</div>
            <div className="map-hide__meta">
              {s.type}
              {s.edid ? ` - ${s.edid}` : ''}
              {' - '}{s.ref}
              {typeof s.dist === 'number' ? ` - à ${s.dist} m de toi` : ''}
            </div>
            <ul className="map-hide__keys">
              <li><Key k="Suppr" /> Confirmer</li>
              <li><Key k="Retour arrière" /> Annuler</li>
            </ul>
          </>
        ) : (
          <>
            <div className="map-hide__title">
              {s.purpose === 'copy' ? 'Retrouver un objet du monde' : 'Masquer un objet de la carte'}
            </div>
            <div className="map-hide__tip">
              Ouvre la console (<Key k="~" />), clique sur l'objet, puis referme la console.
              {s.purpose === 'copy' ? " Un exemplaire neuf du même objet passe en aperçu : tu le places où tu veux." : ''}
            </div>
            <ul className="map-hide__keys">
              <li><Key k="Retour arrière" /> Terminer</li>
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default MapHideOverlay;
